// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"43cefe0a","455":"fa1e4441","977":"2805c0ee"}[chunkId] + ".chunk.js";
};